export default __webpack_public_path__ + "static/media/timer.c2a6034d.svg";